import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const FormUnsavedIndicator: React.FC = () => {
  const { t } = useTranslation(["common"]);
  const {
    formState: { isDirty },
  } = useFormContext();
  return (
    <Box>
      {isDirty && (
        <Text textStyle="small" textColor="primary.600">
          {t("common:unsavedProgress")}
        </Text>
      )}
    </Box>
  );
};
